.outline-container{border-radius:16px;border:1.5px solid transparent}.selected{border:1.5px solid #5a42d0;background:#5a42d00a}
/*# sourceMappingURL=selectable-object.component.css.map */
